import { createApp } from 'vue';
import SpaceContactApp from './PageSpaceContactApp.vue';

export const initPageSpaceContact = () => {
  if (!document.getElementById('space-contact-app')) {
    return;
  }

  createApp(SpaceContactApp)
    .mount('#space-contact-app');
};
